import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { Snackbar as Snack, IconButton } from "@mui/material";

// @mui/icons-material
import Close from "@mui/icons-material/Close";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/snackbarContentStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function SnackbarContent(props) {

  const { message, color, close, icon, rtlActive } = props;

  var action = [];

  const messageData = {
    "iconMessage": icon !== undefined
  };
  const messagesKeys = getKeyArray(messageData);

  const actionRTLData = {
    "actionRTL": rtlActive
  };
  const rtlKeys = getKeyArray(actionRTLData);


  if (close !== undefined) {
    action = [
      <IconButton
        sx={styles.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
      >
        <Close sx={styles.close} />
      </IconButton>
    ];
  }
  return (
    <Snack
      message={
        <div>
          {icon !== undefined ? <props.icon sx={styles.icon} /> : null}
          <span style={getBaseSxStyle(styles, [...messagesKeys])}>{message}</span>
        </div>
      }
      sx={getBaseSxStyle(styles, ['root', color, 'message', ...rtlKeys])}
      action={action}
    />
  );
}

SnackbarContent.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.object,
  rtlActive: PropTypes.bool
};
